export default __webpack_public_path__ + "static/media/421.ede711a4.png";